export const csParaMap = [
  { name: "pārā.", book: 213, para: 3 },
  { name: "pāci.", book: 214, para: 3 },
  { name: "mahāva.", book: 215, para: 3 },
  { name: "cūḷava.", book: 216, para: 3 },
  { name: "pari.", book: 217, para: 3 },
  { name: "pārā.aṭṭha.", book: 138, para: 3 },
  { name: "pārā.aṭṭha.1.", book: 138, para: 3 },
  { name: "pārā.aṭṭha.2.", book: 138, para: 3 },
  { name: "pāci.aṭṭha.", book: 139, para: 3 },
  { name: "mahāva.aṭṭha.", book: 140, para: 3 },
  { name: "cūḷava.aṭṭha.", book: 141, para: 3 },
  { name: "pari.aṭṭha.", book: 142, para: 3 },

  { name: "vi.saṅga.aṭṭha.", book: 208, para: 3 },
  { name: "vajira.ṭī.", book: 209, para: 3 },
  { name: "vi.vi.ṭī.", book: 201, para: 2 },
  { name: "vi.vi.ṭī.cūḷavagga2", book: 201, para: 2 },
  { name: "vi.vi.ṭī.mahāvagga2", book: 201, para: 2 },
  { name: "vi.vi.ṭī.pācittiya2", book: 201, para: 2 },
  { name: "vi.vi.ṭī.parivāra2", book: 201, para: 2 },
  { name: "sārattha.ṭī.1.", book: 204, para: 3 },
  { name: "sārattha.ṭī.2.", book: 205, para: 3 },
  { name: "sārattha.ṭī.3.", book: 206, para: 3 },

  { name: "dī.ni.1.", book: 93, para: 3 },
  { name: "dī.ni.2.", book: 94, para: 3 },
  { name: "dī.ni.3.", book: 95, para: 3 },
  { name: "dī.ni.aṭṭha.1.", book: 103, para: 3 },
  { name: "dī.ni.aṭṭha.2.", book: 104, para: 3 },
  { name: "dī.ni.aṭṭha.3.", book: 105, para: 3 },
  { name: "dī.ni.ṭī.1.", book: 185, para: 3 },
  { name: "dī.ni.ṭī.2.", book: 186, para: 3 },
  { name: "dī.ni.ṭī.3.", book: 187, para: 3 },

  { name: "ma.ni.1.", book: 164, para: 3 },
  { name: "ma.ni.2.", book: 165, para: 3 },
  { name: "ma.ni.3.", book: 166, para: 3 },
  { name: "ma.ni.aṭṭha.1.", book: 130, para: 3 },
  { name: "ma.ni.aṭṭha.2.", book: 131, para: 3 },
  { name: "ma.ni.aṭṭha.3.", book: 132, para: 3 },
  { name: "ma.ni.ṭī.1.", book: 192, para: 3 },
  { name: "ma.ni.ṭī.2.", book: 193, para: 3 },
  { name: "ma.ni.ṭī.3.", book: 194, para: 3 },

  { name: "saṃ.ni.1.", book: 167, para: 3 },
  { name: "saṃ.ni.2.", book: 168, para: 3 },
  { name: "saṃ.ni.3.", book: 169, para: 3 },
  { name: "saṃ.ni.4.", book: 170, para: 3 },
  { name: "saṃ.ni.5.", book: 171, para: 3 },
  { name: "saṃ.ni.aṭṭha.1.", book: 133, para: 3 },
  { name: "saṃ.ni.aṭṭha.2.", book: 134, para: 3 },
  { name: "saṃ.ni.aṭṭha.3.", book: 135, para: 3 },
  { name: "saṃ.ni.ṭī.1.", book: 195, para: 3 },
  { name: "saṃ.ni.ṭī.2.", book: 196, para: 3 },
  { name: "saṃ.ni.ṭī.3.", book: 197, para: 3 },

  { name: "a.ni.1.", book: 84, para: 3 },
  { name: "a.ni.2.", book: 85, para: 3 },
  { name: "a.ni.3.", book: 86, para: 3 },
  { name: "a.ni.4.", book: 87, para: 3 },
  { name: "a.ni.5.", book: 88, para: 3 },
  { name: "a.ni.6.", book: 89, para: 3 },
  { name: "a.ni.7.", book: 90, para: 3 },
  { name: "a.ni.8.", book: 91, para: 3 },
  { name: "a.ni.9.", book: 92, para: 3 },
  { name: "a.ni.10.", book: 82, para: 3 },
  { name: "a.ni.11.", book: 83, para: 3 },

  { name: "paṭi.ma.mātikā1.", book: 151, para: 5 },
  { name: "paṭi.ma.1.", book: 151, para: 81, end: 1360 },
  { name: "paṭi.ma.2.", book: 151, para: 1361 },
  { name: "paṭi.ma.3.", book: 151, para: 1809 },

  { name: "jā.1.1.", book: 148, para: 5 },
  { name: "jā.1.2.", book: 148, para: 851 },
  { name: "jā.1.3.", book: 148, para: 1742 },
  { name: "jā.1.4.", book: 148, para: 2326 },
  { name: "jā.1.5.", book: 148, para: 3065 },
  { name: "jā.1.6.", book: 148, para: 3557 },
  { name: "jā.1.7.", book: 148, para: 4041 },
  { name: "jā.1.8.", book: 148, para: 4589 },
  { name: "jā.1.9.", book: 148, para: 4902 },
  { name: "jā.1.10.", book: 148, para: 5275 },
  { name: "jā.1.11.", book: 148, para: 5871 },
  { name: "jā.1.12.", book: 148, para: 6264 },
  { name: "jā.1.13.", book: 148, para: 6692 },
  { name: "jā.1.14.", book: 148, para: 7188 },
  { name: "jā.1.15.", book: 148, para: 8123 },
  { name: "jā.1.16.", book: 148, para: 9339 },
  { name: "jā.2.17.", book: 147, para: 5 },
  { name: "jā.2.18.", book: 147, para: 765 },
  { name: "jā.2.19.", book: 147, para: 1333 },
  { name: "jā.2.20.", book: 147, para: 1754 },
  { name: "jā.2.21.", book: 147, para: 2326 },
  { name: "jā.2.22.", book: 147, para: 3894 },

  { name: "dha.sa.", book: 73, para: 3 },
  { name: "vibha.", book: 74, para: 3 },
  { name: "yama.1.mūlayamaka.", book: 78, para: 4 },
  { name: "yama.1.khandhayamaka.", book: 78, para: 309 },
  { name: "yama.1.khandhayamaka.", book: 78, para: 309 },
  { name: "yama.1.āyatanayamaka.", book: 78, para: 1463 },
  { name: "yama.1.dhāturamaka.", book: 78, para: 3544 },
  { name: "yama.1.saccayamaka.", book: 78, para: 3809 },
  { name: "yama.2.saṅkhārayamaka.", book: 79, para: 4 },
  { name: "yama.2.anusayayamaka.", book: 79, para: 822 },
  { name: "yama.2.cittayamaka.", book: 79, para: 3204 },
  { name: "yama.3.dhammayamaka.", book: 80, para: 4 },
  { name: "yama.3.indriyayamaka.", book: 80, para: 1122 },

  { name: "dha.sa.aṭṭha.", book: 96, para: 4 },
  { name: "vibha.aṭṭha.", book: 97, para: 4 },
  { name: "yama.aṭṭha.", book: 98, para: 1623 },
  { name: "yama.aṭṭha.āyatanayamaka.", book: 98, para: 1711 },

  { name: "dha.sa.mūlaṭī.", book: 172, para: 3 },
  { name: "vibha.mūlaṭī.", book: 173, para: 3 },
  { name: "yama.mūlaṭī.", book: 174, para: 865 },

  { name: "dha.sa.anuṭī.", book: 175, para: 3 },
  { name: "vibha.anuṭī.", book: 173, para: 1155 },

  { name: "visuddhi.1.", book: 64, para: 2 },
  { name: "visuddhi.2.", book: 65, para: 2 },
  { name: "visuddhi.mahāṭī.1.", book: 66, para: 2 },
  { name: "visuddhi.mahāṭī.2.", book: 67, para: 2 },
  { name: "visuddhi.ṭī.1.", book: 66, para: 2 },
  { name: "visuddhi.ṭī.2.", book: 67, para: 2 },
  { name: "visuddhi.mahā.1.", book: 66, para: 2 },
  { name: "visuddhi.mahā.2.", book: 67, para: 2 },
];
